import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Services from './views/services.vue'
import Clientele from './views/clientele.vue'
import Gallery from './views/gallery.vue'
import ContactUs from './views/contactUs.vue'
import Enquire from './views/enquire.vue'

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      redirect: '/home'
    }, {
      path: '/home',
      name: 'home',
      component: Home
    }, {
      path: '/about-us',
      name: 'about',
      component: About
    }, {
      path: '/services',
      name: 'service',
      component: Services
    }, {
      path: '/clientele',
      name: 'clientele',
      component: Clientele
    }, {
      path: '/gallery',
      name: 'gallery',
      component: Gallery
    }, {
      path: '/contact-us',
      name: 'contactUs',
      component: ContactUs
    }, {
      path: '/enquire',
      name: 'enquire',
      component: Enquire
    }
  ]
})
